var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGooglePlayWhite(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 167.18 49.67",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:#fff;stroke-miterlimit:10;}.cls-2{fill:#fff;}.cls-3{fill:url(#linear-gradient);}.cls-4{fill:url(#linear-gradient-2);}.cls-5{fill:url(#linear-gradient-3);}.cls-6{fill:url(#linear-gradient-4);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 26.71,
    y1: -119.82,
    x2: 6.1,
    y2: -99.21,
    gradientTransform: "matrix(1.04, 0, 0, -1.04, 2.41, -85.23)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00a0ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#00a1ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#00beff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#00d2ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#00dfff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00e3ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 40.43,
    y1: -105.05,
    x2: 10.72,
    y2: -105.05,
    gradientTransform: "matrix(1.04, 0, 0, -1.04, 2.41, -85.23)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffe000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#ffbd00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "orange"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff9c00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 20.2,
    y1: -113.37,
    x2: -7.75,
    y2: -85.42,
    gradientTransform: "matrix(1.04, 0, 0, -1.04, 2.41, -85.23)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff3a44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c31162"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: -3.29,
    y1: -120.22,
    x2: 9.19,
    y2: -107.74,
    gradientTransform: "matrix(1.04, 0, 0, -1.04, 2.41, -85.23)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#32a071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#2da771"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#15cf74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#06e775"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00f076"
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "whitedownload-google-play") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M160.81,49.76H6.94A6.14,6.14,0,0,1,.78,43.67V7.17A6.13,6.13,0,0,1,6.94,1.09H160.81A6.13,6.13,0,0,1,167,7.17v36.5a6.14,6.14,0,0,1-6.15,6.09Z",
    transform: "translate(-0.28 -0.59)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M55.52,9.32a3.86,3.86,0,0,0-2.8,1.13,3.76,3.76,0,0,0-1.16,2.8,3.75,3.75,0,0,0,1.16,2.8,3.9,3.9,0,0,0,2.8,1.12,3.75,3.75,0,0,0,2.8-1.12,3.43,3.43,0,0,0,1-2.53,2.31,2.31,0,0,0-.06-.57l0-.1H55.4V14H58a2.09,2.09,0,0,1-.53,1.27,2.84,2.84,0,0,1-3.91,0,2.64,2.64,0,0,1-.81-2,2.67,2.67,0,0,1,.81-2,2.71,2.71,0,0,1,1.94-.77,2.4,2.4,0,0,1,1.94.82l.08.1.83-.82-.07-.08a3,3,0,0,0-1.19-.85,4.14,4.14,0,0,0-1.56-.32Zm33.16,0a3.78,3.78,0,0,0-2.79,1.14,3.85,3.85,0,0,0-1.13,2.8,3.85,3.85,0,0,0,1.13,2.8,4,4,0,0,0,5.6,0,4,4,0,0,0,0-5.58A3.78,3.78,0,0,0,88.7,9.34Zm-28.29.17V17H65V15.89H61.58V13.82h3V12.7h-3V10.63h3.35V9.49H60.39Zm5.3,0v1.14h2.06V17H69v-6.4H71V9.49Zm8.75,0V17h1.19V9.49Zm2.15,0v1.14h2.06V17h1.19v-6.4h2.07V9.49Zm17.1,0V17h1.19V12.36l0-1L98.44,17h1.18V9.49H98.43v4.39l0,1L95,9.48H93.69Zm-5,1a2.54,2.54,0,0,1,1.91.79,2.67,2.67,0,0,1,.79,2,2.67,2.67,0,0,1-.79,2,2.54,2.54,0,0,1-1.91.79,2.58,2.58,0,0,1-1.92-.79,2.69,2.69,0,0,1-.79-2,2.69,2.69,0,0,1,.79-2,2.59,2.59,0,0,1,1.93-.79Z",
    transform: "translate(-0.28 -0.59)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M84.65,27.56a5.17,5.17,0,1,0,5.25,5.16,5.13,5.13,0,0,0-5.25-5.16Zm0,8.31a3.15,3.15,0,1,1,3-3.15,3,3,0,0,1-3,3.15ZM73.19,27.56a5.17,5.17,0,1,0,5.25,5.16,5.12,5.12,0,0,0-5.25-5.16Zm0,8.31a3.15,3.15,0,0,1,0-6.28,3.14,3.14,0,0,1,0,6.26ZM59.55,29.14v2.2h5.31a4.54,4.54,0,0,1-1.2,2.76,5.54,5.54,0,0,1-4.12,1.61,5.84,5.84,0,0,1,0-11.68,5.62,5.62,0,0,1,4,1.57l1.56-1.55a7.79,7.79,0,0,0-5.57-2.21,8.2,8.2,0,0,0-8.25,8,8.2,8.2,0,0,0,8.25,8.05,7.45,7.45,0,0,0,5.67-2.26,7.2,7.2,0,0,0,1.93-5.13A7.09,7.09,0,0,0,67,29.16H59.52Zm55.77,1.71a4.84,4.84,0,0,0-4.48-3.29,4.94,4.94,0,0,0-4.94,5.17,5.09,5.09,0,0,0,5.2,5.17,5.19,5.19,0,0,0,4.36-2.3l-1.78-1.17a3,3,0,0,1-2.58,1.42,2.67,2.67,0,0,1-2.54-1.57l7-2.86-.25-.59Zm-7.14,1.72a2.86,2.86,0,0,1,2.74-3,2,2,0,0,1,2,1.11l-4.68,1.93Zm-5.69,5h2.3V22.38h-2.3Zm-3.77-8.88h-.08a3.59,3.59,0,0,0-2.75-1.15,5.18,5.18,0,0,0,0,10.35,3.61,3.61,0,0,0,2.75-1.18h.08v.74c0,2-1.07,3-2.79,3a2.89,2.89,0,0,1-2.64-1.85l-2,.82A5,5,0,0,0,96,42.53c2.7,0,5-1.57,5-5.39V27.86H98.73v.85Zm-2.63,7.16a3.15,3.15,0,0,1,0-6.28,2.94,2.94,0,0,1,2.8,3.16A2.92,2.92,0,0,1,96.09,35.87Zm30-13.49h-5.51V37.59h2.3V31.83h3.21a4.74,4.74,0,1,0,0-9.45Zm.06,7.33h-3.27v-5.2h3.27a2.62,2.62,0,1,1,0,5.23Zm14.19-2.18a4.3,4.3,0,0,0-4.09,2.33l2,.85a2.17,2.17,0,0,1,2.09-1.12,2.21,2.21,0,0,1,2.42,2v.16a5.21,5.21,0,0,0-2.4-.59c-2.19,0-4.43,1.21-4.43,3.43a3.54,3.54,0,0,0,3.82,3.35,3.25,3.25,0,0,0,2.93-1.48h.08V37.6H145V31.76c0-2.69-2-4.2-4.67-4.2Zm-.28,8.33c-.75,0-1.79-.36-1.79-1.28,0-1.18,1.3-1.63,2.43-1.63a4.15,4.15,0,0,1,2.1.52,2.78,2.78,0,0,1-2.74,2.41Zm13-8-2.63,6.6h-.08l-2.72-6.6H145.2l4.1,9.22L147,42.23h2.4l6.32-14.34h-2.56Zm-20.69,9.74h2.3V22.38h-2.3V37.6Z",
    transform: "translate(-0.28 -0.59)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M14.74,8.17l-.1.09A2.52,2.52,0,0,0,14.05,10V38a2.54,2.54,0,0,0,.59,1.78l.1.08L30.6,24.21v-.38L14.74,8.17Z",
    transform: "translate(-0.28 -0.59)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M35.88,29.44,30.6,24.21v-.37l5.29-5.23.12.07,6.26,3.52c1.79,1,1.79,2.63,0,3.64L36,29.35l-.13.07Z",
    transform: "translate(-0.28 -0.59)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M36,29.37,30.6,24l-16,15.78a2.12,2.12,0,0,0,2.67.07L36,29.37",
    transform: "translate(-0.28 -0.59)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M36,18.68,17.31,8.18a2.12,2.12,0,0,0-2.67.08L30.6,24Z",
    transform: "translate(-0.28 -0.59)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M17.31,39.69l25-14A2.36,2.36,0,0,0,43.61,24a2.2,2.2,0,0,1-1.34,1.82l-25,14c-1.79,1-3.26.16-3.26-1.87v-.18c0,2,1.47,2.84,3.26,1.85Z",
    transform: "translate(-0.28 -0.59)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGooglePlayWhite);
export default __webpack_public_path__ + "static/media/google-play-white.8f303936483bc044c9bc2edb31e8774c.svg";
export { ForwardRef as ReactComponent };